import React from 'react';
import { Loader2 } from 'lucide-react';

export default function MarkAsRestConfirmationModal({
  isOpen,
  weekdayName,
  onConfirm,
  onCancel,
  isLoading = false,
}) {
  React.useEffect(() => {
    if (!isOpen) return;
    const handleEscape = (e) => {
      if (e.key === 'Escape' && !isLoading) onCancel();
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onCancel, isLoading]);

  if (!isOpen) return null;

  const dayLabel = weekdayName ? ` ${weekdayName}` : ' this day';

  return (
    <div
      className="fixed inset-0 z-[110] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
      onClick={() => !isLoading && onCancel()}
      role="dialog"
      aria-modal="true"
      aria-labelledby="mark-as-rest-title"
    >
      <div
        className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-md"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 id="mark-as-rest-title" className="text-lg font-bold text-gray-900 mb-2">
          Mark{dayLabel} as rest?
        </h3>
        <p className="text-sm text-gray-600 mb-6">
          This removes the workout from this day. Exercise edits on this day will be lost unless
          the same plan is still used on another day.
        </p>
        <div className="flex gap-3">
          <button
            type="button"
            onClick={onCancel}
            disabled={isLoading}
            className="flex-1 px-4 py-2.5 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium text-white bg-orange-primary hover:bg-orange-600 rounded-lg disabled:opacity-50"
          >
            {isLoading && <Loader2 className="w-4 h-4 animate-spin" />}
            {isLoading ? 'Updating…' : 'Mark as rest'}
          </button>
        </div>
      </div>
    </div>
  );
}
